<template>
    <div>
        <v-card 
            class="pa-4 ma-0" 
            outlined
        >
            <alert-component v-if="alerts.store.status" :alert="alerts.store" />

            <div class="text-h6 mb-4    ">Proposta - Código {{ item.codigo }} </div>
            <main-show :object="item" />
            
        </v-card>
    </div>    
</template>

<script>
import MainShow from './MainShow.vue';
import AlertComponent from '@/components/alert/AlertComponent.vue'

export default {
    name: 'ProposalShow',

    components: {
        MainShow,
        AlertComponent
    },

    computed: {
        me () {
          return this.$store.state.auth.me
        }
    },

    data () {
        return {
            item: {},
            alerts: {
                store: {
                    status: false,
                    type: 'success',
                    icon: 'mdi-check-circle',
                    messages: ['Proposta cadastrada com sucesso! A gerência dará sequência à análise, e você poderá acompanhar o andamento pelo alerta de propostas na página inicial do sistema. O status do imóvel foi alterado para "Com proposta".']
                },
            }    
        }
    },

    async mounted() {
        window.scrollTo(0, 0);

        if(this.$route.query.store && this.$route.query.store == 'true'){
            this.alerts.store.status = true;
        }

        this.proposalId = this.$route.params.id;
        if (this.proposalId) {
            await this.loadProposal(this.proposalId);
        } else {
            // Tratar caso o ID não exista na URL
            alert('ID da proposta não informado.');
            this.$router.push('/proposals/search'); // redireciona, por exemplo
        }
    },

    methods: {
        getValue(value) {
            return Math.trunc(value || 0)
        },

        async loadProposal(id) {
            try {
                const data = await this.$store.dispatch('loadProposal', id);
                this.item = data.data; // Salva os dados no estado do componente
                this.item.valor_proposta = this.getValue(this.item.valor_proposta)
            } catch (error) {
                console.error('Erro ao carregar proposta:', error);
                alert('Não foi possível carregar a proposta. Verifique o ID ou tente novamente.');
                this.$router.push('/proposals/search'); // redireciona em caso de erro
            }
        }
    }
}
</script>